import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Observer from '@researchgate/react-intersection-observer';

class HbIntersectionMonitor extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onIntersectionChange: PropTypes.func,
    onlyOnce: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.previousY = 0;
  }

  handleChange = (intersectionEntry, unobserve) => {
    const {
      boundingClientRect: {
        y: currentY,
      },
      isIntersecting,
    } = intersectionEntry;

    const {onIntersectionChange, onlyOnce} = this.props;

    if (onlyOnce && isIntersecting) {
      unobserve();
    }

    const isDownwards = currentY < this.previousY;

    this.previousY = currentY;

    onIntersectionChange(intersectionEntry, {isDownwards});
  }

  render() {
    const {children} = this.props;

    return (
      <Observer
        {...this.props}
        onChange={this.handleChange}>
        {children}
      </Observer>
    );
  }
}

export default HbIntersectionMonitor;
